import { Edge, Node, NodeSelectionChange } from "reactflow"
import { GraphSelectionModel } from "@features/graph/graphViewModel"
import { GraphNodeChange } from "@features/graph/changes/graphApplyChanges"

export const graphSelectionChangeHandler = (
  change: NodeSelectionChange | { id: string; selected: boolean },
  nodeInternals: Map<string, Node>,
  edges: Edge[],
) => {
  const nodes: GraphNodeChange[] = []
  const node = nodeInternals.get(change.id)
  nodes.push({ selected: change.selected, id: change.id })

  // if node is selected we want to add edges of parents and children to be also selected
  if (node && !node.id.startsWith("g") && change.selected) {
    for (const edge of edges) {
      if (edge.target == change.id) {
        nodes.push({ selected: false, id: edge.source })
        GraphSelectionModel.parent.add(edge.source)
        GraphSelectionModel.parentEdges.add(edge.id)
      } else if (edge.source == change.id) {
        nodes.push({ selected: false, id: edge.target })
        GraphSelectionModel.child.add(edge.target)
        GraphSelectionModel.childEdges.add(edge.id)
      }
    }
  }

  return nodes
}
